import React from 'react';
import PropTypes from 'prop-types';

function IconNext({ size = 24, color = `#C2C2C2`, className }) {
  return (
    <svg width={size} height={size} className={className} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path fillRule="evenodd" clipRule="evenodd" d="M16 5.5L17.6667 5.5C17.7551 5.5 17.8399 5.53424 17.9024 5.59519C17.9649 5.65614 18 5.7388 18 5.825L18 18.175C18 18.2612 17.9649 18.3439 17.9024 18.4048C17.8399 18.4658 17.7551 18.5 17.6667 18.5L16 18.5C15.9116 18.5 15.8268 18.4658 15.7643 18.4048C15.7018 18.3439 15.6667 18.2612 15.6667 18.175L15.6667 5.825C15.6667 5.7388 15.7018 5.65614 15.7643 5.59519C15.8268 5.53424 15.9116 5.5 16 5.5ZM6.52267 5.85139L15.2688 11.7325C15.4609 11.8616 15.4609 12.1384 15.2688 12.2675L6.52267 18.1485C6.30153 18.2974 6 18.143 6 17.881L6 6.11893C6 5.85705 6.30153 5.70267 6.52267 5.85139Z" fill={color}/>
    </svg>
  )
}

IconNext.propTypes = {
  size: PropTypes.number.isRequired,
  color: PropTypes.string,
  className: PropTypes.string
}

export default IconNext;
